import React, { Fragment, useState } from 'react';
// import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import Modal from 'react-modal';
import { topicSuggestionsFetch, topicFollow, searchV2 } from '../../../actions/index';
import { ProfileThumb } from '../CardComponents';
import { Icon } from '../Icon';
import { gtmSend } from '../../../helpers';
import cx from '../../../styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const SelectTopic = (props) => {
    const { t } = props;
    const [changeTopic, setChangeTopic] = useState(false);
    const onChangeTopic = () => {
        if (props.topic) {
            return props.addNotification(t('cannot_change_topic'), 'error');
        } else {
            setChangeTopic(true)
        }
    }
    const toggleChangeTopic = () => {
        setChangeTopic(false)
    }
    return (
        <Fragment>
            <div className={cx('selected-topic-section')}>
                <p className={cx('selected-section')}>{t('selected_topic')}</p>
                <div className={cx('topic-wrap')}>
                    <div className={cx('topic-details')}>
                        <ProfileThumb size="large" img={props.groupImage ? props.groupImage : ""} altName={`${props.groupName} icon`} />
                        <p className={cx('topic-name')}>{props.groupName}</p>
                    </div>
                    <div className={cx('change-topic')} onClick={() => { onChangeTopic(); gtmSend('post_compose', 'Post', 'Compose', 'Change Topic', 0, { action: 'Change Topic' }); }}>
                        {t('change_topic')}
                    </div>
                </div>
            </div>
            <ChangeTopicScreen
                changeTopic={changeTopic}
                groupId={props.groupId}
                groupName={props.groupName}
                groupImage={props.groupImage}
                t={t}
                setSelectedTopic={props.setSelectedTopic}
                toggleChangeTopic={toggleChangeTopic}
                topicSuggestionsFetch={props.topicSuggestionsFetch}
                searchV2={props.searchV2}
                topicFollow={props.topicFollow}
                content={props.content}
                setLoading={props.setLoading} />
        </Fragment>
    )
}

const ChangeTopicScreen = (props) => {
    const { t } = props;
    const [topicsList, setTopicsList] = useState([]);
    const [followedTopics, setFollowedTopics] = useState([]);
    const [mostFollowing, setMostFollowing] = useState([]);
    const [searchTopicData, setSearchTopicData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [noTopicFound, setNoTopicFound] = useState(false);
    const [viewAllTopics, setViewAllTopics] = useState(false);
    const [followTopic, setFollowTopic] = useState(false);
    const [seeAll, setSeeAll] = useState(false);
    const topicSuggestionData = () => {
        props.setLoading(true)
        props.topicSuggestionsFetch(props.content)
            .then(async (data) => {
                await data.response.suggested_groups.map((topic) => {
                    topic && topic.member === 0 ? setMostFollowing(mostFollowing => [...mostFollowing, topic]) : setFollowedTopics(followed => [...followed, topic])
                    setTopicsList(list => [...list, topic])
                })
                props.setLoading(false)
            })
            .catch((err) => {
                console.log("We have err after topic api call", err);
                props.setLoading(false)
            })
    }

    const afterOpenTopicChange = () => {
        setTopicsList([]); setFollowedTopics([]); setMostFollowing([]); setSearchTopicData([]); setSearchTerm('');
        topicSuggestionData()
        const searchInput = document.querySelector('.first-screen')
        searchTopic(searchInput)
    }

    const changeSeeAll = () => {
        setSeeAll(false)
    }

    const clearState = (e) => {
        setSearchTerm(e.target.value);
        setSearchTopicData([]);
        setNoTopicFound(false)
    }

    const searchTopic = (searchInput) => {
        let timeout = setTimeout(function () { }, 0)
        if (searchInput) {
            searchInput.addEventListener('keyup', e => {
                clearTimeout(timeout);
                setSearchTerm(e.target.value);
                setSearchTopicData([]);
                timeout = setTimeout(() => {
                    if (e.target.value.length >= 1) {
                        props.setLoading(true)
                        props.searchV2(e.target.value, 1, 'group', true)
                            .then(async (data) => {
                                if (data && data.response && data.response[0]) {
                                    await data.response[0].data.map((topic) => {
                                        setSearchTopicData(oldArray => [...oldArray, topic])
                                        setNoTopicFound(false)
                                    })
                                } else {
                                    setNoTopicFound(true)
                                }
                                props.setLoading(false)
                            })
                            .catch((err) => {
                                console.log("We have err after topic api call", err);
                                setNoTopicFound(true);
                                props.setLoading(false);
                            })
                    }
                }, 1000)
            })
        }
    }

    const toggleViewAllTopic = () => {
        setViewAllTopics(!viewAllTopics); setSearchTerm(''); setSearchTopicData([]); setNoTopicFound(false);
    }

    const afterOpenViewAllTopic = () => {
        const searchInput = document.querySelector('.second-screen')
        searchTopic(searchInput)
    }

    const onSelectChange = (topicId, topicName, topicImage, member, type, query = '') => {
        changeSeeAll();
        let isNotMember = false;
        props.setSelectedTopic(topicId, topicName, topicImage);
        member === 0 ? isNotMember = true : isNotMember = false;
        type === 'Searched Topic' && query.length > 0 ?
            gtmSend('post_compose', 'Post', 'Compose', `${type} - ${topicName} || Search Query: ${query}`, 0, { action: type, group_id: topicId, group_name: topicName })
            :
            gtmSend('post_compose', 'Post', 'Compose', `${type} - ${topicName} || ${isNotMember ? 'Unfollowed' : 'Folllowed'}`, 0, { action: type, group_id: topicId, group_name: topicName });
        setTimeout(() => {
            setViewAllTopics(false);
            props.toggleChangeTopic();
            isNotMember ? setFollowTopic(true) : '';
        }, 200)
    }

    const toggleFollowTopic = () => {
        setFollowTopic(!followTopic)
    }

    const joinTopic = () => {
        props.topicFollow(props.groupId);
        gtmSend('topic_follow', 'Topics', 'Follow', `${props.groupName} ||Ask the Question Flow`, 0, { screen: 'Ask the Question Flow', group_id: props.groupId, group_name: props.groupName });
        toggleFollowTopic();
    }

    return (
        <Fragment>
            <Modal
                isOpen={props.changeTopic}
                onRequestClose={props.toggleChangeTopic}
                onAfterOpen={afterOpenTopicChange}
                overlayClassName={"change-topic-modal"}
            >
                <span className={cx("close-modal")} onClick={props.toggleChangeTopic}>
                    <Icon name="cross-regular-dark-smd" />
                </span>
                <div className={cx('change-topic-wrap')}>
                    <div className={cx('search-wrap')}>
                        <Icon name="search-icon-regular" />
                        <input type="text" className={cx('search-topic first-screen')} placeholder={t('search_topic')} onChange={(e) => clearState(e)} ></input>
                    </div>
                    {
                        followedTopics && followedTopics.length > 0 && searchTerm === '' &&
                        <div className={cx('following-wrap')}>
                            <p className={cx('topic-type')}>{t('topics_you_are_following')}</p>
                            <div className={cx('wrapper')}>
                                {
                                    followedTopics.map((topic, key) => {
                                        if (key < 5 && topic.member === 1) {
                                            return (
                                                <div className={cx('following')} key={key} onClick={()=>{onSelectChange(topic.id, topic.name, topic.image, topic.member, 'Followed Topics')}}>
                                                    <div className={cx('select-wrap')}>
                                                        <ProfileThumb className={cx('topic-img')} size="large" img={topic.image ? topic.image : ""} altName={`${topic.name} icon`} />
                                                        <input
                                                            id="topic-input"
                                                            value={topic.id}
                                                            type="radio"
                                                            checked={topic.id == props.groupId ? true : false} />
                                                    </div>
                                                    <p className={cx('topic-name')}>{topic.name}</p>
                                                </div>
                                            )
                                        }
                                    })
                                }
                                {
                                    followedTopics && followedTopics.length > 5 && searchTerm === '' &&
                                    <div className={cx('seeAllButton')} onClick={() => { toggleViewAllTopic(); setSeeAll(true); gtmSend('post_compose', 'Post', 'Compose', 'View All Topics', 0, { action: 'View All Topics' }); }}>
                                        <span>{t('see_all')}</span>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                    {
                        mostFollowing && mostFollowing.length > 0 && searchTerm === '' &&
                        <div className={cx('most-followed-wrap')}>
                            <p className={cx('topic-type')}>{t('most_followed_topics')}</p>
                            {
                                mostFollowing.map((topic, key) => {
                                    if (key < 5) {
                                        return (
                                            <div className={cx('most-followed')} key={key} onClick={()=>{onSelectChange(topic.id, topic.name, topic.image, topic.member, 'Most Followed Topics')}}>
                                                <div className={cx('topic-details')}>
                                                    <ProfileThumb className={cx('topic-img')} size="large" img={topic.image ? topic.image : ""} altName={`${topic.name} icon`} />
                                                    <div className={cx('details-wrap')}>
                                                        <p className={cx('topic-name')}>{topic.name}</p>
                                                        <p className={cx('topic-desc')}>{topic.description}</p>
                                                    </div>
                                                </div>
                                                <div className={cx('radio-wrap')}>
                                                    <input
                                                        id="topic-input"
                                                        value={topic.id}
                                                        type="radio"
                                                        checked={topic.id == props.groupId ? true : false} />
                                                </div>
                                            </div>
                                        )
                                    }
                                })
                            }
                        </div>
                    }
                    <SearchTopicScreen
                        searchTopicData={searchTopicData}
                        searchTerm={searchTerm}
                        noTopicFound={noTopicFound}
                        groupId={props.groupId}
                        onSelectChange={onSelectChange} />
                </div>
                {
                    searchTerm === '' &&
                    <div className={cx(`view-all-wrap ${mostFollowing.length > 4 ? 'sticky' : ''}`)}>
                        <button className={cx('view-all-topics')} onClick={() => { setViewAllTopics(true); gtmSend('post_compose', 'Post', 'Compose', 'View All Topics', 0, { action: 'View All Topics' }); }}>{t('view_all_topics')}</button>
                    </div>
                }
            </Modal>
            <ViewAllTopicScreen
                t={t}
                viewAllTopics={viewAllTopics}
                toggleViewAllTopic={toggleViewAllTopic}
                afterOpenViewAllTopic={afterOpenViewAllTopic}
                onSelectChange={onSelectChange}
                groupId={props.groupId}
                topicsList={topicsList}
                followedTopics={followedTopics}
                searchTopicData={searchTopicData}
                searchTerm={searchTerm}
                noTopicFound={noTopicFound}
                clearState={clearState}
                changeSeeAll={changeSeeAll}
                seeAll={seeAll} />
            <FollowTopic
                t={t}
                groupId={props.groupId}
                groupName={props.groupName}
                groupImage={props.groupImage}
                followTopic={followTopic}
                toggleFollowTopic={toggleFollowTopic}
                joinTopic={joinTopic} />
        </Fragment>
    );
}

const SearchTopicScreen = (props) => {
    return (
        <div>
            {
                props.searchTopicData && props.searchTopicData.length > 0 && props.searchTerm && props.searchTerm.length > 0 &&
                <div className={cx('most-followed-wrap')}>
                    {props.searchTopicData.map((topic, key) => {
                        return (
                            <div className={cx('most-followed')} key={key} onClick={() => props.onSelectChange(topic.id, topic.name, topic.image, topic.member, 'Searched Topic', props.searchTerm)}>
                                <div className={cx('topic-details')}>
                                    <ProfileThumb className={cx('topic-img')} size="large" img={topic.image ? topic.image : ""} altName={`${topic.name} icon`} />
                                    <div className={cx('details-wrap')}>
                                        <p className={cx('topic-name')}>{topic.name}</p>
                                        <p className={cx('topic-desc show')}>{topic.description}</p>
                                    </div>
                                </div>
                                <div className={cx('radio-wrap')}>
                                    <input
                                        id="topic-input"
                                        value={topic.id}
                                        type="radio"
                                        checked={topic.id == props.groupId ? true : false} />
                                </div>
                            </div>
                        )
                    })}
                </div>
            }
            {
                props.noTopicFound && props.searchTopicData && props.searchTopicData.length === 0 && props.searchTerm && props.searchTerm.length > 0 &&
                <p className={cx('no-results')}>No Results</p>
            }
        </div>
    )
}

const ViewAllTopicScreen = (props) => {
    const { t } = props;
    return (
        <Modal
            isOpen={props.viewAllTopics}
            onRequestClose={() => { props.toggleViewAllTopic(); props.changeSeeAll() }}
            onAfterOpen={props.afterOpenViewAllTopic}
            overlayClassName={"change-topic-modal viewAll"}
        >
            <span className={cx("close-modal")} onClick={() => { props.toggleViewAllTopic(); props.changeSeeAll() }}>
                <Icon name="cross-regular-dark-smd" />
            </span>
            <div className={cx('change-topic-wrap')}>
                <div className={cx('search-wrap')}>
                    <Icon name="search-icon-regular" />
                    <input type="text" className={cx('search-topic second-screen')} placeholder={t('search_topic')} onChange={(e) => props.clearState(e)} ></input>
                </div>
                {
                    props.seeAll && props.followedTopics && props.followedTopics.length && props.searchTerm === '' &&
                    <div className={cx('most-followed-wrap')}>
                        <p className={cx('topic-type padding')}>{t('topics_you_are_following')}</p>
                        {
                            props.followedTopics.map((topic, key) => {
                                return (
                                    <div className={cx('most-followed')} key={key} onClick={() => props.onSelectChange(topic.id, topic.name, topic.image, topic.member)}>
                                        <div className={cx('topic-details')}>
                                            <ProfileThumb className={cx('topic-img')} size="large" img={topic.image ? topic.image : ""} altName={`${topic.name} icon`} />
                                            <div className={cx('details-wrap')}>
                                                <p className={cx('topic-name')}>{topic.name}</p>
                                                <p className={cx('topic-desc show')}>{topic.description}</p>
                                            </div>
                                        </div>
                                        <div className={cx('radio-wrap')}>
                                            <input
                                                id="topic-input"
                                                value={topic.id}
                                                type="radio"
                                                checked={topic.id == props.groupId ? true : false} />
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
                {
                    !props.seeAll && props.topicsList && props.topicsList.length > 0 && props.searchTerm === '' &&
                    <div className={cx('most-followed-wrap')}>
                        <p className={cx('topic-type padding')}>{t('all_topics')}</p>
                        {
                            props.topicsList.map((topic, key) => {
                                return (
                                    <div className={cx('most-followed')} key={key} onClick={() => props.onSelectChange(topic.id, topic.name, topic.image, topic.member, 'All Topics')}>
                                        <div className={cx('topic-details')}>
                                            <ProfileThumb className={cx('topic-img')} size="large" img={topic.image ? topic.image : ""} altName={`${topic.name} icon`} />
                                            <div className={cx('details-wrap')}>
                                                <p className={cx('topic-name')}>{topic.name}</p>
                                                <p className={cx('topic-desc show')}>{topic.description}</p>
                                            </div>
                                        </div>
                                        <div className={cx('radio-wrap')}>
                                            <input
                                                id="topic-input"
                                                value={topic.id}
                                                type="radio"
                                                checked={topic.id == props.groupId ? true : false} />
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
                <SearchTopicScreen
                    searchTopicData={props.searchTopicData}
                    searchTerm={props.searchTerm}
                    noTopicFound={props.noTopicFound}
                    groupId={props.groupId}
                    onSelectChange={props.onSelectChange}
                />
            </div>
        </Modal>
    );
}
const FollowTopic = (props) => {
    const { t } = props;
    return (
        <Modal
            isOpen={props.followTopic}
            onRequestClose={props.toggleFollowTopic}
            overlayClassName={"follow-topic-modal"}
        >
            <div className={cx('follow-wrap')}>
                <ProfileThumb img={props.groupImage ? props.groupImage : ""} size="large" altName={`${props.groupName} icon`} />
                <p className={cx('group-name')}>{props.groupName}</p>
                <p className={cx('ask-follow')}>{t('follow_topic_text')}</p>
                <div className={cx('follow-button')}>
                    <button className={cx('cancel-follow')} onClick={() => { props.toggleFollowTopic(); gtmSend('topic_cancel', 'Topics', 'Cancel', `${props.groupName} ||Ask Question Flow`, 0, { screen: 'Ask Question Flow', group_id: props.groupId, group_name: props.groupName }); }}>{t('cancel')}</button>
                    <button className={cx('submit-follow')} onClick={props.joinTopic}>{t('yes')}</button>
                </div>
            </div>
        </Modal>
    );
}

//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        topicSuggestionsFetch,
        topicFollow,
        searchV2,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(SelectTopic));
